module.exports = __webpack_public_path__ + "static/img/folkSong.48774f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/folkSong.png
// module id = uF+c
// module chunks = 26